import Avatar from "./Avatar.js";
import Name from "./Name.js";
import SubName from "./SubName.js";
import Bio from "./Bio.js";
import Location from "./Location.js";
import Email from "./Email.js";

const Personal = () => {
  return (
    <>
      <Avatar />
      <Name />
      <SubName />
      {/* <Bio /> */}
      <Location />
      <Email />
    </>
  );
};

export default Personal;
